/** @format */

import template from './gb-notification-popout-a.html';
import './gb-notification-popout-a.scss';

export const GbNotificationPopoutAComponent = {
    template,
    require: {
        gbNotificationWidget: '^^',
    },
    bindings: {
        notif: '<',
    },
    controller: class GbNotificationPopoutAComponent {
        constructor() {
            'ngInject';
        }
    },
};
